import { render } from "./CompareAnswer.vue?vue&type=template&id=380c5617&scoped=true&ts=true"
import script from "./CompareAnswer.vue?vue&type=script&lang=ts"
export * from "./CompareAnswer.vue?vue&type=script&lang=ts"

import "./CompareAnswer.vue?vue&type=style&index=0&id=380c5617&lang=less&scoped=true"
import "./CompareAnswer.vue?vue&type=style&index=1&id=380c5617&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380c5617"]])

export default __exports__